import { render, staticRenderFns } from "./CrawlerController.vue?vue&type=template&id=4fbf9c18&scoped=true&"
import script from "./CrawlerController.vue?vue&type=script&lang=js&"
export * from "./CrawlerController.vue?vue&type=script&lang=js&"
import style0 from "./CrawlerController.vue?vue&type=style&index=0&id=4fbf9c18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbf9c18",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
